/** @format */

const SysConfig = {
  clientId: "e4a4435474e14a48aae224eee0f357c5", // 플랫폼에서 관리하는 클라이언트 아이디( 웹수발주 전용 )
  userInfo: {},
  members: [],
  compInfo: {},
  token: "",
  devMode: process.env.NODE_ENV == ("dev" || "local"),
  ForeignCurrencyFormat: "#,##0.00",
};

const PageConfig = {
  pagePath: "",
  pageName: "",
};

const CommonCode = {
  commonGroup: [],
  commonDetail: [],
};

export {SysConfig, PageConfig, CommonCode};

/**
{
  "userInfo" : {
    "errors" : [ ],
    "emplyrId" : "shipwork01f",
    "password" : "RMzRWlNpZyBr3j/UA09cBAbhxhhefvzWKn+hX7C6w6U=",
    "userNm" : "쉽워크01외국",
    "emailAdres" : "kaiji109@gmail.com",
    "offmTelno" : "",
    "mbtlnum" : "01062802175",
    "compNm" : "(주)쉽워크01",
    "compId" : 322,
    "mailAuthDe" : null,
    "mailAuthYn" : "N",
    "emplyrSttusCode" : "P",
    "exitReason" : null,
    "fxnum" : "",
    "memberType" : "SUPPLIER",
    "memberJoinType" : null,
    "userTyp" : "ROLE_COMP_CHARGER",
    "customsUserType" : "EDU",
    "customsSubsType" : "F",
    "customsIsMailSend" : true,
    "customsMarkId" : 722,
    "sbscrbDe" : null,
    "createId" : "shipwork01",
    "createDate" : "2020-07-14T08:43:28.000+0000",
    "updateId" : "shipwork01f",
    "updateDate" : "2020-08-31T06:08:33.000+0000",
    "checkboxForPromote" : false,
    "checkboxForCustoms" : true,
    "checkboxForCustomsMobile" : true,
    "checkboxForOrder" : true,
    "checkboxForCode" : true,
    "businessRegNum" : null,
    "esntlId" : "USRCNFRM_00000003207",
    "groupId" : "GROUP_00000000000000",
    "orgnztId" : "ORGNZT_0000000000000",
    "areaNo" : null,
    "brthdy" : null,
    "crtfcDnValue" : null,
    "detailAdres" : null,
    "emplNo" : null,
    "houseAdres" : null,
    "houseEndTelno" : null,
    "houseMiddleTelno" : null,
    "ihidnum" : null,
    "ofcpsNm" : null,
    "passwordCnsr" : null,
    "passwordHint" : null,
    "pstinstCode" : null,
    "sexdstnCode" : null,
    "postCode" : null
  },
  "members" : [ {
    "errors" : [ ],
    "emplyrId" : "test",
    "password" : "9MIXiGCBeiwl0ssxhaold5sOyvF8MIRZJiGOF6GKn4k=",
    "userNm" : "길동이",
    "emailAdres" : "kaiji109@gmail.com",
    "offmTelno" : "111111",
    "mbtlnum" : "01062802175",
    "compNm" : "(주)쉽워크01",
    "compId" : 322,
    "mailAuthDe" : null,
    "mailAuthYn" : "N",
    "emplyrSttusCode" : "P",
    "exitReason" : null,
    "fxnum" : "",
    "memberType" : "SUPPLIER",
    "memberJoinType" : null,
    "userTyp" : "ROLE_COMP_USER",
    "customsUserType" : "NONE",
    "customsSubsType" : "NONE",
    "customsIsMailSend" : true,
    "customsMarkId" : 0,
    "sbscrbDe" : null,
    "createId" : null,
    "createDate" : "2020-04-13T09:24:15.000+0000",
    "updateId" : "shipwork01f",
    "updateDate" : "2020-08-31T06:08:37.000+0000",
    "checkboxForPromote" : false,
    "checkboxForCustoms" : true,
    "checkboxForCustomsMobile" : true,
    "checkboxForOrder" : true,
    "checkboxForCode" : true,
    "businessRegNum" : null,
    "esntlId" : "USRCNFRM_00000003120",
    "groupId" : "GROUP_00000000000000",
    "orgnztId" : "ORGNZT_0000000000000",
    "areaNo" : null,
    "brthdy" : null,
    "crtfcDnValue" : null,
    "detailAdres" : null,
    "emplNo" : null,
    "houseAdres" : null,
    "houseEndTelno" : null,
    "houseMiddleTelno" : null,
    "ihidnum" : null,
    "ofcpsNm" : null,
    "passwordCnsr" : null,
    "passwordHint" : null,
    "pstinstCode" : null,
    "sexdstnCode" : null,
    "postCode" : null
  }, {
    "errors" : [ ],
    "emplyrId" : "shipwork01f",
    "password" : "RMzRWlNpZyBr3j/UA09cBAbhxhhefvzWKn+hX7C6w6U=",
    "userNm" : "쉽워크01외국",
    "emailAdres" : "kaiji109@gmail.com",
    "offmTelno" : "",
    "mbtlnum" : "01062802175",
    "compNm" : "(주)쉽워크01",
    "compId" : 322,
    "mailAuthDe" : null,
    "mailAuthYn" : "N",
    "emplyrSttusCode" : "P",
    "exitReason" : null,
    "fxnum" : "",
    "memberType" : "SUPPLIER",
    "memberJoinType" : null,
    "userTyp" : "ROLE_COMP_CHARGER",
    "customsUserType" : "EDU",
    "customsSubsType" : "F",
    "customsIsMailSend" : true,
    "customsMarkId" : 722,
    "sbscrbDe" : null,
    "createId" : "shipwork01",
    "createDate" : "2020-07-14T08:43:28.000+0000",
    "updateId" : "shipwork01f",
    "updateDate" : "2020-08-31T06:08:33.000+0000",
    "checkboxForPromote" : false,
    "checkboxForCustoms" : true,
    "checkboxForCustomsMobile" : true,
    "checkboxForOrder" : true,
    "checkboxForCode" : true,
    "businessRegNum" : null,
    "esntlId" : "USRCNFRM_00000003207",
    "groupId" : "GROUP_00000000000000",
    "orgnztId" : "ORGNZT_0000000000000",
    "areaNo" : null,
    "brthdy" : null,
    "crtfcDnValue" : null,
    "detailAdres" : null,
    "emplNo" : null,
    "houseAdres" : null,
    "houseEndTelno" : null,
    "houseMiddleTelno" : null,
    "ihidnum" : null,
    "ofcpsNm" : null,
    "passwordCnsr" : null,
    "passwordHint" : null,
    "pstinstCode" : null,
    "sexdstnCode" : null,
    "postCode" : null
  }, {
    "errors" : [ ],
    "emplyrId" : "shipwork01d",
    "password" : "sFEiB42VhJHfzX1oLRDkKlWH+nZ9MUWZIMMXqg4jWV0=",
    "userNm" : "쉽워크01내국",
    "emailAdres" : "kaiji109@gmail.com",
    "offmTelno" : "0519667000",
    "mbtlnum" : "01062802175",
    "compNm" : "(주)쉽워크01",
    "compId" : 322,
    "mailAuthDe" : null,
    "mailAuthYn" : "N",
    "emplyrSttusCode" : "P",
    "exitReason" : null,
    "fxnum" : "0519668000",
    "memberType" : "SUPPLIER",
    "memberJoinType" : "CORP_MEMBER_SUPPLIER",
    "userTyp" : "ROLE_COMP_CHARGER",
    "customsUserType" : "USER",
    "customsSubsType" : "D",
    "customsIsMailSend" : true,
    "customsMarkId" : 709,
    "sbscrbDe" : "2020-04-27T11:02:59.000+0000",
    "createId" : "shipwork01",
    "createDate" : "2020-04-27T11:02:59.000+0000",
    "updateId" : "shipwork01f",
    "updateDate" : "2020-08-31T06:08:01.000+0000",
    "checkboxForPromote" : false,
    "checkboxForCustoms" : true,
    "checkboxForCustomsMobile" : true,
    "checkboxForOrder" : true,
    "checkboxForCode" : true,
    "businessRegNum" : null,
    "esntlId" : "USRCNFRM_00000002888",
    "groupId" : "GROUP_00000000000000",
    "orgnztId" : "ORGNZT_0000000000000",
    "areaNo" : null,
    "brthdy" : null,
    "crtfcDnValue" : null,
    "detailAdres" : null,
    "emplNo" : null,
    "houseAdres" : null,
    "houseEndTelno" : null,
    "houseMiddleTelno" : null,
    "ihidnum" : null,
    "ofcpsNm" : null,
    "passwordCnsr" : null,
    "passwordHint" : null,
    "pstinstCode" : null,
    "sexdstnCode" : null,
    "postCode" : null
  }, {
    "errors" : [ ],
    "emplyrId" : "shipwork01",
    "password" : "YVp0KcSLVdXKrHeX6kjOHKAz9fpopSkZOPLjxYC4lE4=",
    "userNm" : "쉽워크01관리자",
    "emailAdres" : "kaiji109@gmail.com",
    "offmTelno" : "",
    "mbtlnum" : "01062802175",
    "compNm" : "(주)쉽워크01",
    "compId" : 322,
    "mailAuthDe" : null,
    "mailAuthYn" : "N",
    "emplyrSttusCode" : "P",
    "exitReason" : "",
    "fxnum" : "",
    "memberType" : "SUPPLIER",
    "memberJoinType" : "CORP_MEMBER_SUPPLIER",
    "userTyp" : "ROLE_COMP_MANAGER",
    "customsUserType" : "CORP",
    "customsSubsType" : "NONE",
    "customsIsMailSend" : true,
    "customsMarkId" : 0,
    "sbscrbDe" : "2020-04-27T07:49:22.000+0000",
    "createId" : null,
    "createDate" : "2020-04-27T07:49:22.000+0000",
    "updateId" : "shipwork01f",
    "updateDate" : "2020-08-31T06:08:51.000+0000",
    "checkboxForPromote" : false,
    "checkboxForCustoms" : true,
    "checkboxForCustomsMobile" : true,
    "checkboxForOrder" : true,
    "checkboxForCode" : true,
    "businessRegNum" : null,
    "esntlId" : "USRCNFRM_00000002867",
    "groupId" : "GROUP_00000000000000",
    "orgnztId" : "ORGNZT_0000000000000",
    "areaNo" : null,
    "brthdy" : null,
    "crtfcDnValue" : null,
    "detailAdres" : null,
    "emplNo" : null,
    "houseAdres" : null,
    "houseEndTelno" : null,
    "houseMiddleTelno" : null,
    "ihidnum" : null,
    "ofcpsNm" : null,
    "passwordCnsr" : null,
    "passwordHint" : null,
    "pstinstCode" : null,
    "sexdstnCode" : null,
    "postCode" : null
  } ],
  "compInfo" : {
    "errors" : [ ],
    "companyInfoId" : 322,
    "cmsNo" : "",
    "address" : "부산광역시 동구 중앙대로 240 (초량동)",
    "companyType" : "SUPPLIER",
    "addressDetail" : "6",
    "addressDetailEn" : "6 ",
    "addressEn" : "240, Jungang-daero, Dong-gu, Busan",
    "buildingNumber" : "2617010100111930005004243",
    "roadNameCode" : "261702000010",
    "businessCondition" : "업태",
    "businessItem" : "종목",
    "businessRegNum" : "6029900001",
    "ceoName" : "김워크01",
    "ceoNameEn" : "김워크01",
    "compNm" : "(주)쉽워크01",
    "compNmEn" : "(주)쉽워크01",
    "email" : "kaiji109@gmail.com",
    "fax" : "0519668000",
    "homepage" : "",
    "videoLink" : "<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/tJieVCgGzhs\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>",
    "introduce" : "상세소개입니다.\r\n",
    "postCode" : "48732",
    "star" : 0,
    "tag" : null,
    "tel" : "051-966-7000",
    "username" : "shipwork01",
    "createDate" : "2020-04-27T10:10:15.000+0000",
    "updateDate" : "2020-12-22T01:31:30.000+0000",
    "latitude" : null,
    "longitude" : null,
    "categories" : null,
    "brands" : null,
    "ports" : null,
    "certs" : null,
    "associations" : null,
    "agents" : null,
    "manager" : null,
    "chargers" : null,
    "ecatalog" : null
  }
}


*/
